// @ts-nocheck
/* eslint-disable */
export const flNewsIcon = {
    data: `<svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 6.75H21V19H1V1H17V16.5M3.75 14H14.25M4.5 9V5H13.5V9H4.5Z" stroke="currentColor" stroke-width="1.5"/></svg>`,
    name: 'news' as const
};